<template>
  <nav class="nav nav--loaded">
    <ul class="nav__list">
      <li class="nav__item">
        <router-link
          :to="{ name: 'home' }"
          :class="homeClasses"
        >
          <span class="nav__link-icon">
            <svg
              aria-hidden="true"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 320 512"
            >
              <path
                fill="currentColor"
                d="M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"
              ></path>
            </svg>
          </span>
          <span class="nav__link-text">
            {{ t('home.menuTitle') }}
          </span>
        </router-link>
      </li>
      <li class="nav__item">
        <router-link
          :to="{ name: 'history' }"
          class="nav__link"
          data-cy="nav-history"
        >
          <span class="nav__link-icon">
            <svg
              aria-hidden="true"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"
              ></path>
            </svg>
          </span>
          <span class="nav__link-text">
            {{ t('history.menuTitle') }}
          </span>
        </router-link>
      </li>
      <li class="nav__item">
        <router-link
          :to="{ name: 'efriends' }"
          :class="efriendsClasses"
          data-cy="nav-efriends"
        >
          <span class="nav__link-icon">
            <svg
              aria-hidden="true"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 -60 640 512"
            >
              <path
                fill="currentColor"
                d="M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
              ></path>
            </svg>
          </span>
          <span class="nav__link-text">
            {{ t('efriends.menuTitle') }}
          </span>
        </router-link>
      </li>
      <li class="nav__item">
        <router-link :to="{ name: 'devices' }" :class="devicesClasses">
          <span class="nav__link-icon">
            <svg
              aria-hidden="true"
              focusable="false"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <path
                fill="currentColor"
                d="M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"
              ></path>
            </svg>
          </span>
          <span class="nav__link-text">
            {{ t('devices.menuTitle') }}
                      </span>
        </router-link>
      </li>
      <li class="nav__item" v-if="!isDemoUser">
        <router-link :to="{ name: 'shop' }" :class="shopClasses">
          <span class="nav__link-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
              <path
                fill="currentColor"
                d="M96 0C107.5 0 117.4 8.19 119.6 19.51L121.1 32H541.8C562.1 32 578.3 52.25 572.6 72.66L518.6 264.7C514.7 278.5 502.1 288 487.8 288H170.7L179.9 336H488C501.3 336 512 346.7 512 360C512 373.3 501.3 384 488 384H159.1C148.5 384 138.6 375.8 136.4 364.5L76.14 48H24C10.75 48 0 37.25 0 24C0 10.75 10.75 0 24 0H96zM128 464C128 437.5 149.5 416 176 416C202.5 416 224 437.5 224 464C224 490.5 202.5 512 176 512C149.5 512 128 490.5 128 464zM512 464C512 490.5 490.5 512 464 512C437.5 512 416 490.5 416 464C416 437.5 437.5 416 464 416C490.5 416 512 437.5 512 464z"
              />
            </svg>
          </span>
          <span class="nav__link-text">
            {{ t('shop.menuTitle') }}
          </span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
  import { useStrings } from '@/composables/useStrings.ts'
  import { useAccountStore } from '@/stores/useAccountStore'
  import { useCubeStore } from '@/stores/useCubeStore'
  import { useCurrentReadsStore } from '@/stores/useCurrentReadsStore'
  import { storeToRefs } from 'pinia';

  export default {
    name: 'navigation',
    setup(){
      const accountStore = useAccountStore()
      const cubeStore = useCubeStore()
      const currentReadsStore = useCurrentReadsStore()
      const { isDemoUser } = storeToRefs(accountStore)
      const { t } = useStrings()
      return{
        t,
        cubeStore,
        accountStore,
        currentReadsStore,
        isDemoUser,
      }
    },
    computed: {
      homeClasses() {
        let classes = ['nav__link']
        if (
          this.cubeStore.numNotificationsForTypeGroup('meter-read') > 0 ||
          (!this.accountStore.properties.isCommunityless && !this.currentReadsStore.isCubeReachable)
        ) {
          classes.push('nav__link--has-notifications')
        }
        return classes.join(' ')
      },
      efriendsClasses() {
        let classes = ['nav__link']
        if (this.cubeStore.numNotificationsForTypeGroup('community') > 0) {
          classes.push('nav__link--has-notifications')
        }
        return classes.join(' ')
      },
      devicesClasses() {
        let classes = ['nav__link']
        if (this.cubeStore.numNotificationsForTypeGroup('devices') > 0) {
          classes.push('nav__link--has-notifications')
        }
        return classes.join(' ')
      },
      shopClasses() {
        let classes = ['nav__link']
        if (this.cubeStore.numNotificationsForTypeGroup('shop') > 0) {
          classes.push('nav__link--has-notifications')
        }
        return classes.join(' ')
      },
    },
  }
</script>

<style lang="scss">
  .nav {
    opacity: 0;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: $nav-height;
    z-index: 10;
    box-shadow: 0px -8px 15px -7px rgba(0, 0, 0, 0.1);
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    background: $white;
    display: flex;

    @media (min-width: $bp-sm) {
      height: $nav-height-sm;
    }

    &--loaded {
      opacity: 1;
    }

    &__list {
      list-style: none;
      display: flex;
      padding: 0;
      margin: 0;
      flex-basis: 100%;
    }

    &__item {
      flex-basis: 25%;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__link {
      display: block;
      cursor: pointer;
      color: $grey;
      transition: $transition-base;
      position: relative;
      width: 100%;
      height: 100%;

      @include hover-focus-active {
        opacity: 1;
        color: $community;

        .nav__link-text {
          color: $grey-darker;
        }
      }

      &--has-notifications {
        &::before {
          @include notification-dot;

          left: 50%;
          top: $spacer025;
          margin-left: $spacer10;

          @media (min-width: $bp-ssm) {
            margin-left: $spacer20;
          }

          @media (min-width: $bp-ssm) {
            top: 0.3rem;
          }

          @media (min-width: $bp-sm) {
            margin-left: $spacer30;
          }
        }
      }

      &--clicked {
        transition: transform 0.05s ease-in-out 0s;
        animation: click-scale 0.6s ease-in-out 1;
      }

      &--active {
        opacity: 1;
        transition: $transition-base;

        .nav__link-icon {
          color: $community;
        }

        .nav__link-text {
          color: $grey-darker;
        }
      }

      &-icon {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: $spacer05;
        transition: $transition-base;

        svg {
          width: $nav-icon-size-min;
          height: $nav-icon-size-min;

          @media (min-width: $bp-sm) {
            width: $nav-icon-size-sm;
            height: $nav-icon-size-sm;
          }
        }
      }

      &-text {
        color: $grey-dark;
        display: block;
        font-size: $nav-font-size;
        transition: $transition-base;
        flex-basis: 100%;
        font-weight: 600;
        text-shadow: none;

        @media (min-width: $bp-sm) {
          font-size: $nav-font-size-sm;
        }
      }
    }
  }
</style>
